import type { ReactNode } from 'react';

import { Trans } from '@lingui/react/macro';

import { BASE_PATH } from '@/constants/config';

interface AuthLayoutProps {
  children: ReactNode;
  rightPanel?: ReactNode;
}

export function AuthLayout({ children, rightPanel }: AuthLayoutProps) {
  return (
    <>
      <div className="flex min-h-screen bg-primary">
        {/* Left side: form */}
        <div className="flex min-w-0 flex-1 flex-col px-8 py-8">
          {/* Logo */}
          <img
            src={`${BASE_PATH}/logo-dark.svg`}
            alt="Respondent"
            className="h-8 self-start"
          />

          {/* Form content */}
          <div className="flex flex-1 items-center justify-center py-8">
            <div className="w-full max-w-[480px]">{children}</div>
          </div>

          {/* Copyright */}
          <p className="text-sm text-tertiary">
            <Trans>&copy; Respondent {new Date().getFullYear()}</Trans>
          </p>
        </div>

        {/* Right side: marketing panel (hidden on mobile) */}
        {rightPanel && (
          <div className="hidden flex-1 py-4 pr-4 lg:flex">
            <div className="w-full overflow-hidden rounded-[20px]">
              {rightPanel}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
